import {copyText} from '@github-ui/copy-to-clipboard'
import {CommandActionListItem, ScopedCommands} from '@github-ui/ui-commands'
import {KebabHorizontalIcon, LinkIcon, QuoteIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

interface ConversationItemActions {
  onQuoteReply?: () => void
  link: string
}

export function ConversationItemActions({onQuoteReply, link}: ConversationItemActions) {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton icon={KebabHorizontalIcon} variant="invisible" size="small" aria-label="More actions" />
      </ActionMenu.Anchor>

      <ActionMenu.Overlay align="end">
        <ActionList>
          {onQuoteReply && (
            <CommandActionListItem
              commandId="pull-requests:quote-reply"
              onSelect={onQuoteReply}
              leadingVisual={<QuoteIcon />}
            >
              Quote reply
            </CommandActionListItem>
          )}

          <ActionList.Item onSelect={() => copyText(link)}>
            <ActionList.LeadingVisual>
              <LinkIcon />
            </ActionList.LeadingVisual>
            Copy link
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

export function ConversationItemActionsProvider({
  onQuoteReply,
  children,
}: React.PropsWithChildren<Pick<ConversationItemActions, 'onQuoteReply'>>) {
  return <ScopedCommands commands={{'pull-requests:quote-reply': onQuoteReply}}>{children}</ScopedCommands>
}
